import React, { useEffect, useState } from "react";
import blue_add_icon from "../../../common/assets/images/blueaddicon.png";
import { Dropdown, DropdownItem } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { assignedByList } from "../../../store/queueSlice";
import LdsRoller from "../../../utils/LdsRoller";

const AssignedCoders = ({
  assignedCoders,
  selectedCoder,
  setSelectedCoder,
  setFormData
}) => {
  const dispatch = useDispatch();
  const [showCoderAddSection, setShowCoderAddSection] = useState(false);
  const codersList = useSelector((state) => state.queue.codersList);
  const codersListLoading=useSelector((state)=>state.queue.loadingCodersData);
  const handleAddAssignedCoders = (e) => {
    e.preventDefault();
    setShowCoderAddSection((prev) => !prev);
  };
   const handleCoderSelect = (coder) => {
    setSelectedCoder((prev) => {
      const isSelected = prev.some((c) => c.user_id === coder.user_id);
      const updatedCoders = isSelected
        ? prev.filter((c) => c.user_id !== coder.user_id) // Remove if selected
        : [...prev, coder]; // Add if not selected
      // Log the selected coder and updated state
      // console.log("Selected coder:", coder.user_name, "Updated coders:", updatedCoders);
      // Update formData with the updated coders
      setFormData((prev) => ({
        ...prev,
        assignedCoders: updatedCoders,
      }));
      return updatedCoders;
    });
  };
  useEffect(() => {
    dispatch(assignedByList());
  }, [dispatch]);
  // console.log(codersList, "coders");

  return (
    codersListLoading ? (
      <LdsRoller/>
    ) : (
      <div className="assigned-coders-wrapper">
        {assignedCoders?.map((eachCoder) => (
          <div className="coder-label-wrapper" key={eachCoder.user_id}>
            <img />
            <span>{eachCoder.user_name}</span>
            <label> (Junior)</label>
          </div>
        ))}
        {showCoderAddSection && (
          <Dropdown
            className="form-dropdown assigned-coders"
            style={{ width: "auto" }}
          >
            <Dropdown.Toggle className="queue-assigned-coders">
              {/* {selectedCoder?.user_name || "Assign to"} */}
                {selectedCoder.length > 0
              ? selectedCoder.map((c) => c.user_name).join(", ")
              : "Assign to"}
            </Dropdown.Toggle>
  
           <Dropdown.Menu className="queue-assigned-coders-menu">
              {codersList?.data?.users?.map((eachCoder) => (
                <div
                  key={eachCoder.user_id}
                  className="queue-assigned-coders-item"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent dropdown from closing
                    handleCoderSelect(eachCoder);
                  }}
                  style={{ padding: "6px 12px", display: "flex", alignItems: "center", cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    checked={selectedCoder.some(
                      (c) => c.user_id === eachCoder.user_id
                    )}
                  
                    style={{ marginRight: "8px" }}
                    onClick={() => handleCoderSelect(eachCoder)} // prevent dropdown close from checkbox click
                  />
                  {eachCoder.user_name}
                </div>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
        <button
          className="route-adding-btn m-auto"
          onClick={handleAddAssignedCoders}
        >
          {showCoderAddSection ? "" : <img src={blue_add_icon} alt="plus" />}
          {showCoderAddSection ? "Cancel" : "Assign Coders"}
        </button>
      </div>
    )
  );
};

export default AssignedCoders;
